import React from 'react'
import './css/works.css'
const projects = [
    {
        "name": "FireChat",
        "img": "https://raw.githubusercontent.com/akash-kamat/firechat/master/pic2.png",
        "github_url": "https://github.com/akash-kamat/firechat",
        "hosted_url": "https://akash-kamat.github.io/firechat",
        "description": "A google authenticated public chat-app (made using firebase)"
    },
    {
        "name": "AniChar",
        "img": "https://i.ibb.co/Z8w7rx0/anichar3.jpg",
        "github_url": "https://github.com/akash-kamat/anichar",
        "hosted_url": "https://akash-kamat.github.io/anichar",
        "description": "An authenticated MERN stack webapp to find new Anime characters and add them to your list!"
    },
    {
        "name": "CaptureIt",
        "img": "https://raw.githubusercontent.com/akash-kamat/captureIt/main/Captureit.PNG",
        "github_url": "https://github.com/akash-kamat/captureIt",
        "hosted_url": "https://akash-kamat.github.io/captureIt/",
        "description": "Capture screenshot of any webpage from its URL (Flash Api)"
    },
    {
        "name": "Aim Labs (ultra lite)",
        "img": "https://i.ibb.co/020LPXC/aimlab1.png",
        "github_url": "https://github.com/akash-kamat/Aim-Labs-pureJS",
        "hosted_url": "https://akash-kamat.github.io/Aim-Labs-pureJS/",
        "description": "WebGame to test AIM/reaction time made with pure JavaScript"
    },
    {
        "name": "Confus",
        "img": "https://github.com/akash-kamat/confus-frontend/raw/main/Screenshot%20from%202022-06-18%2018-51-30.png?raw=true",
        "github_url": "https://github.com/akash-kamat/firechat",
        "hosted_url": "https://confus.netlify.app/",
        "description": "Full stack MERN webapp to post confessions anonymously"
    },
    {
        "name": "Memer",
        "img": "https://i.ibb.co/KGWYJ3s/memer01.png",
        "github_url": "https://github.com/akash-kamat/Memer",
        "hosted_url": "https://akash-kamat.github.io/Memer/",
        "description": "A 'not so impressive' Meme generator from templates fetched from an API, made using react"
    },
    {
        "name": "To-Do",
        "img": "https://i.ibb.co/5YV6fjt/todo1.png",
        "github_url": "https://github.com/akash-kamat/todoapp",
        "hosted_url": "https://akash-kamat.github.io/todoapp",
        "description": "Minimal todo webapp made using Js and utilising localstorage"
    },
    {
        "name": "Pokedex",
        "img": "https://i.ibb.co/V9tNwVT/pokedex.png",
        "github_url": "https://github.com/akash-kamat/Pokedex",
        "hosted_url": "https://akash-kamat.github.io/Pokedex/",
        "description": "Simple pokedex using pokeApi and also my first react app"
    },
    {
        "name": "Bored",
        "img": "https://i.ibb.co/b5C7J7M/bored1.pngttps://i.ibb.co/Z8w7rx0/anichar3.jpg",
        "github_url": "https://github.com/akash-kamat/Bored",
        "hosted_url": "https://akash-kamat.github.io/Bored",
        "description": "bored?"
    }
]
function Works({ motion }) {
    function openUrl(url) {
        window.open(url, '_blank')
    }
    return (
        <div className='right-section works background'>
            <div className='work-text'>
                These are my projects:
            </div>
            <div className='showcase-container'>
                {
                    projects.map((e, i) => {
                        return (
                            <div key={i} className={`div${i + 1}`} id="project-block">
                                <h1 className='project-title'>{e.name}</h1><span className='dot1'></span><span className='dot2'></span><span className='dot3'></span>
                                <img src={e.img} alt='project' className='project-img' />
                                <div className='hover-container'>
                                    <p className='project-desc'>{e.description}</p>
                                    <div className='hover-btn-container'>
                                        <button title='open github' className='github-link material-symbols-outlined' onClick={() => openUrl(e.github_url)} >code</button>
                                        <button title='open website' className='hosted-link material-symbols-outlined' onClick={() => openUrl(e.hosted_url)} >expand_content</button>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Works